import { ExcelMapperCol } from "./excel-mapper-col";
import { ExcelMapperConverter } from "./excel-mapper-converter";

export class ExcelMapperConfig {
	HeaderRow:number = 1;
	Cols:ExcelMapperCol[] = [];
	ExtraData:any = {};

	allowedHeaders:string[] = [];

	public constructor(data?:any) {
		if (!data) return;
		this.HeaderRow = data.HeaderRow;
		this.Cols = ((data.Cols || []) as any[]).map(v=>new ExcelMapperCol(v));
		this.ExtraData = data.ExtraData || {};
	}

	public getJSON(){
		return {
			HeaderRow: this.HeaderRow,
			Cols: this.Cols.map(c=>c.getJSON()),
			ExtraData: this.ExtraData || {}
		};
	}

	public createConverter():ExcelMapperConverter{
		return new ExcelMapperConverter(new ExcelMapperConfig(this.getJSON()));
	}
}